import React, {Component} from 'react';
const $ = require('jquery');
// $.DataTable = require('datatables.net');
// import 'datatables.net-dt/css/jquery.dataTables.min.css';
// require('datatables.net-buttons/js/dataTables.buttons.min');
const jzip = require('jzip');
// require('datatables.net-buttons/js/buttons.html5.min');
// import 'datatables.net-buttons-dt/css/buttons.dataTables.css';
window.JSZip = jzip;
const id = 'id' + Math.random().toString(16).slice(2);
const columns = [
  {
    title: '#',
    data: 'ROW_NO'
  },
  {
    title: 'Username',
    data: 'USERNAME'
  },
  {
    title: 'Name',
    data: 'NAME'
  },
  {
    title: 'Number of months of continuous scan',
    data: 'CONTINUED'
  },
  {
    title: 'Jan',
    data: 'Jan'
  },
  {
    title: 'Feb',
    data: 'Feb'
  },
  {
    title: 'Mar',
    data: 'Mar'
  },
  {
    title: 'Apr',
    data: 'Apr'
  },
  {
    title: 'May',
    data: 'May'
  },
  {
    title: 'Jun',
    data: 'Jun'
  },
  {
    title: 'Jul',
    data: 'Jul'
  },
  {
    title: 'Aug',
    data: 'Aug'
  },
  {
    title: 'Sep',
    data: 'Sep'
  },
  {
    title: 'Oct',
    data: 'Oct'
  },
  {
    title: 'Nov',
    data: 'Nov'
  },
  {
    title: 'Dec',
    data: 'Dec'
  },
  {
    title: 'Total Redemption',
    data: 'SUM_ALL'
  },
  {
    title: 'Grab',
    data: 'Grab'
  },
  {
    title: 'Shopee',
    data: 'Shopee'
  },
  {
    title: 'Tmall',
    data: 'Tmall'
  },
  {
    title: '7-Eleven',
    data: '7-Eleven'
  },
  {
    title: 'Name',
    data: 'NAME'
  },
  {
    title: 'Tel',
    data: 'TEL'
  },
  {
    title: 'Email',
    data: 'EMAIL'
  },
  {
    title: 'Date Reg.',
    data: 'DATE_REG'
  },
  {
    title: 'Age',
    data: 'AGE_RANGE'
  },
  {
    title: 'Gender',
    data: 'GENDER'
  }
];

function reloadTableData(names) {
  console.log("reload: "+names.length);
  const table = $(`#${id}`).DataTable();
  table.clear();
  table.rows.add(names);
  table.draw();
}

function updateTable(names) {
  console.log("update: "+names.length);
  const table = $(`#${id}`).DataTable();
  let dataChanged = false;
  table.rows().every(function () {
    const oldNameData = this.data();
    const newNameData = names.find((nameData) => {
      return nameData.name === oldNameData.name;
    });
    if (oldNameData.nickname !== newNameData.nickname) {
      dataChanged = true;
      this.data(newNameData);
    }
    return true;
  });
  console.log(dataChanged);
  if (dataChanged) {
    table.draw();
  }
}

function hideCols(country) {
  console.log("hide");
  var column;
  column = $(`#${id}`).DataTable().column(17);
  column.visible(false);
  column = $(`#${id}`).DataTable().column(18);
  column.visible(false);
  column = $(`#${id}`).DataTable().column(19);
  column.visible(false);
  column = $(`#${id}`).DataTable().column(20);
  column.visible(false);

  if (country === 'MY'){
    column = $(`#${id}`).DataTable().column(17);
    column.visible(true);
    column = $(`#${id}`).DataTable().column(18);
    column.visible(true);
  }
  if (country === 'HK' || country === 'MO'){
    column = $(`#${id}`).DataTable().column(20);
    column.visible(true);
  }  
  if (country === 'TW'){
    column = $(`#${id}`).DataTable().column(20);
    column.visible(true);
  }  
  if (country === 'CN'){
    column = $(`#${id}`).DataTable().column(19);
    column.visible(true);
  }
}

class Table7 extends Component {
  componentDidMount() {
    $(`#${id}`).DataTable({
      dom: 'Bfrtip',
      data: this.props.names,
      columns,
      searching: true,
      paging: true,
      ordering: true,
      scrollX: true,
      errMode : 'none',
      buttons: [
        'copy',
        {
          extend: 'csv',
          title: `data_loyalty_csv_${Date.now()}`
        },
        {
          extend: 'excelHtml5',
          title: `data_loyalty_excel_${Date.now()}`
        }
      ]
    });
    $.fn.dataTable.ext.errMode = 'none';
  }

  componentWillUnmount() {
    $(`#${id}`).DataTable().destroy(true);
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.country !== this.props.country) {
      hideCols(nextProps.country);
    }

    if (nextProps.names.length !== this.props.names.length) {
      reloadTableData(nextProps.names);
    } else {
      //updateTable(nextProps.names);
      reloadTableData(nextProps.names);
    }
    return false;
  }

  render() {
    return (
      <div>
        <table ref="main" className="display" id={id} />
      </div>
    );
  }
}
export default Table7;
